module.exports = __webpack_public_path__ + "static/media/okta.843d352c.svg";